import React from "react";
import App from "@graphic/App";
import LoadingSpinner from "../../shared/ui/LoadingSpinner";
import { SectionWrapper } from "../../../styles/common";

const Nuri3D = ({ enteringTime, selectedNoradId, secondaryID, NURI, timeFormat, defaultLabel }) => {
  return (
    <SectionWrapper>
      <h2 className="title">Global View (3D)</h2>
      <main className="content">
        {/* <img src='/static/earth.gif' alt='earth-img' /> */}
        {enteringTime ? (
          <App
            map="/static/earth-large.jpg"
            bump="/static/bump-large.jpg"
            clouds="/static/clouds-large.jpg"
            time={enteringTime}
            noradId={selectedNoradId}
            satType={NURI}
            secondaryID={secondaryID}
            timeFormat={timeFormat}
            defaultLabel={defaultLabel}
          />
        ) : (
          <LoadingSpinner />
        )}
      </main>
    </SectionWrapper>
  );
};
export default Nuri3D;
